import { Flex } from '@chakra-ui/react'
import { useParams } from 'react-router-dom'
import { TabListaPorReuniao } from '../../../../Jornada/ReuniaoOne/Dashboard/Corporativo/Components/TabListaPorReuniao'
import { iLinhaTabela } from '../../../../Jornada/ReuniaoOne/Dashboard/Individual'

interface iProps {
  tabela: iLinhaTabela[]
  onOrdenar: (filtro: number, ascendente: boolean) => void
}

export const TabReuniaoOne: React.FC<iProps> = ({ tabela, onOrdenar }) => {
  const { colaboradorId } = useParams<{colaboradorId: string}>()

  return (
    <Flex flexDirection={'column'} gap='1rem'>
      {tabela.length > 0 && tabela?.filter(e => e.convidado.id === colaboradorId).length > 0 &&
        <Flex flexDir={'column'}>
          <h3>Reuniões que o colaborador foi convidado</h3>
          <TabListaPorReuniao
            onOrdenar={(filtro, ascendente) => { onOrdenar(filtro, ascendente) }}
            reunioes={tabela.filter(r => r.convidado.id === colaboradorId)}
            individual={true}
            telaColaborador={'criadas'}
          />
        </Flex>
      }

      {tabela.length > 0 && tabela?.filter(e => e.criador.id === colaboradorId).length > 0 &&
        <Flex flexDir={'column'}>
          <h3>Reuniões solicitadas pelo colaborador</h3>
          <TabListaPorReuniao
            reunioes={tabela.filter(e => e.criador.id === colaboradorId)}
            individual={true}
            telaColaborador={'solicitadas'}
            onOrdenar={(filtro, ascendente) => { onOrdenar(filtro, ascendente) }}
          />
        </Flex>
      }
    </Flex>
  )
}
